---
title: Table of Contents
description: Hover over the visual Table Of Contents on the right side of the page for an easier and funner way to jump to your Boxes, Lists, and Line dividers.
category: Navigating
updated: 2026-11-03
video: https://updates.kinopio.club/pages/help/posts/minimap/toc.mp4
---

# Table of Contents

Hover over the visual Table Of Contents on the right side of the page for an easier and funner way to jump to your Boxes, Lists, and Line dividers. (The TOC is not available on mobile due to screen size restrictions).

<video class="medium" autoplay loop muted playsinline>
  <source src="https://updates.kinopio.club/pages/help/posts/minimap/toc.mp4">
</video>

## Hide Items from the TOC

You can hide individual items from the Table of Contents to keep things neat and minimal, or to highlight the main sections in a space. Hover over the TOC and click the button at the bottom, then toggle the visibility off of whatever you want to hide. 

Keep in mind that hidden items are hidden to all space collaborators and viewers – everyone sees the same TOC. 

<video class="small" autoplay loop muted playsinline>
  <source src="https://updates.kinopio.club/pages/help/posts/minimap/toc-hide-items.mp4">
</video>
